// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"3edbe8dd","125":"65e502c7","137":"9751efb3","356":"242a6625","705":"2d53e197","712":"bd505b76"}[chunkId] + ".css";
};